import React from 'react';

interface AdSlotProps {
  id?: string;
  className?: string;
  variant?: 'inline' | 'sidebar' | 'rectangle';
}

/**
 * AdSlot component for Google AdSense integration
 * Standard ad sizes supported:
 * - inline: Responsive horizontal (min 300px width)
 * - sidebar: 300x600 vertical banner
 * - rectangle: 300x250 medium rectangle
 */
const AdSlot: React.FC<AdSlotProps> = ({ 
  id, 
  className = '', 
  variant = 'inline' 
}) => {
  const variantStyles = {
    inline: 'min-h-[90px] w-full min-w-[300px]',
    sidebar: 'w-[300px] min-h-[600px]',
    rectangle: 'w-[300px] h-[250px]'
  };

  return (
    <div 
      id={id}
      className={`
        ad-slot 
        bg-muted/30 
        border border-dashed border-muted-foreground/20 
        rounded-lg 
        flex items-center justify-center
        ${variantStyles[variant]}
        ${className}
      `}
      aria-label="Advertisement"
      data-ad-slot={id}
    >
      <span className="text-xs text-muted-foreground/50 select-none">
        Advertisement
      </span>
    </div>
  );
};

export default AdSlot;
